import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { SeoElement } from '../SeoElement';
import { SeoImageLink } from '../SeoImageLink';

const SeoListFragment = graphql(/* GraphQL */ `
  fragment SeoListFragment on Product {
    name
    slug
    media {
      url
    }
    seoLinks: seo(locale: $locale) {
      ...SeoElementFragment
    }
  }
`);

export type SeoListProps = {
  productData: FragmentType<typeof SeoListFragment>;
};

export const SeoList = ({ productData }: SeoListProps) => {
  const { media, name, slug, seoLinks } = getFragmentData(SeoListFragment, productData);

  return (
    <>
      {media.length > 0 && media[0].url && (
        <SeoImageLink productName={name!} slug={slug!} imgSrc={media[0].url} />
      )}
      {seoLinks && <SeoElement data={seoLinks} />}
    </>
  );
};
